import React, { useState, useEffect } from "react";
import "../../styles/Home-module.css";
import {
  formateDateClient,
  formattedDate,
  getKhmerCalendarDate,
  linkPath,
  linkPathReport,
} from "../../share/helper";
import { getCurrentUser, getPermission } from "../../share/getProfile";
import dayjs from "dayjs";
import { QRCode } from "antd";
import { BiLogoTelegram } from "react-icons/bi";
import { GrLocation } from "react-icons/gr";
import { FooterPagePrint } from "./FooterPagePrint";

const ComponentToPrint_Index1 = ({
  reason,
  node,
  date_start,
  date_end,
  support_by,
  car_using,
  liststaff,
  Org_ImagePath,
  name_signature,
  postion_signature,
  org_cover_by,
  location,
  time_meeting,
  clothing_meeting,
  date_document,
  date_signature,
  do_in_provinceName,
  location_contact,
  org_type_code,
}) => {
  const moment = require("moment");
  require("@thyrith/momentkh")(moment);
  let api_date_document = moment(date_document, "YYYY-MM-DD");
  let api_date_signature = moment(date_signature, "YYYY-MM-DD");

  const [finalTop, setFinalTop] = useState(0); // State for the final `top` value
  const OrgProfile = getCurrentUser();
  const topMainMargine = 385;
  const textX = 130; // Adjust X coordinate as needed
  const textY = 560; // Adjust Y coordinate as needed
  let khmerDateDocument = api_date_document.toLunarDate();
  let khmerDateSingnature = api_date_signature.toLunarDate();
  // Helper to calculate the image path
  const printpath = (value) => {
    return value <= 3
      ? linkPathReport + "mission.jpg"
      : linkPathReport + "mission.jpg";
  };

  // Helper to convert to Khmer numerals
  const toKhmerNumeral = (number) => {
    const khmerDigits = ["០", "១", "២", "៣", "៤", "៥", "៦", "៧", "៨", "៩"];
    return String(number)
      .split("")
      .map((digit) => khmerDigits[digit])
      .join("");
  };
  const calculateFinalTop = () => {
    if (liststaff && liststaff.length > 0) {
      return topMainMargine + (liststaff.length - 1) * 22 + 30;
    }
    return 0;
  };
  const getKhmerPeriod = (time) => {
    const hour = dayjs(time, "HH:mm:ss").hour();
    if (hour >= 12 && hour < 13) {
      return "ថ្ងៃត្រង់"; // Midday
    } else if (hour < 12) {
      return "ព្រឹក"; // Morning
    } else {
      return "រសៀល"; // Afternoon/Evening
    }
  };

  const P_finalTop = calculateFinalTop(); // Calculate directly
  useEffect(() => {
    if (liststaff && liststaff.length > 0) {
      console.log("Calculating top value...");
      const calculatedTop = 370 + (liststaff.length - 1) * 22;
      setFinalTop(calculatedTop + 100);
      console.log("Final top value:", calculatedTop);
    } else {
      console.log("liststaff is empty or undefined.");
      setFinalTop(0);
    }
  }, [liststaff]);
  const top =
    liststaff && Array.isArray(liststaff) && liststaff.length <= 1
      ? P_finalTop + 200
      : liststaff && Array.isArray(liststaff) && liststaff.length <= 2
      ? P_finalTop + 200
      : liststaff && Array.isArray(liststaff) && liststaff.length <= 3
      ? P_finalTop + 180
      : liststaff && Array.isArray(liststaff) && liststaff.length <= 4
      ? P_finalTop + 130
      : liststaff && Array.isArray(liststaff) && liststaff.length <= 5
      ? P_finalTop + 80
      : liststaff && Array.isArray(liststaff) && liststaff.length <= 6
      ? P_finalTop + 40
      : liststaff && Array.isArray(liststaff) && liststaff.length <= 7
      ? P_finalTop + 15
      : P_finalTop;

  const Nodes = () => {
    return (
      <div>
        <div
          className="text-overlay"
          style={{
            top: 330,
            left: textX,
            right: 20,
          }}
        >
          <table
            className="text-on-image-name_letters_mission"
            style={{ borderCollapse: "collapse", width: "100%" }}
          >
            <tr>
              <td
                style={{
                  width: "140px",
                  lineHeight: "2",
                  verticalAlign: "top", // Align content at the top
                }}
                className="text-on-image-name_rightmanager_mission"
              >
                <span> សូមអញ្ជើញ :</span>
              </td>
              <td style={{ verticalAlign: "top", lineHeight: "2" }}>
                {liststaff.map((staff, index) => (
                  <span
                    key={index}
                    className="text-on-image-name_rightmanager_mission"
                  >
                    {staff.frontname} {staff.fullname} {staff.position} <br />
                  </span>
                ))}
              </td>
            </tr>
            <tr>
              <td
                style={{ width: "80px", lineHeight: "2", verticalAlign: "top" }}
              >
                ដើម្បី :
              </td>
              <td style={{ lineHeight: "2" }}> {reason} </td>
            </tr>
            <tr>
              <td style={{ width: "80px" }}>ពេលវេលា :</td>
              <td>
                {date_start} {" វេលាម៉ោង "}{" "}
                {time_meeting
                  ? `${dayjs(time_meeting, "HH:mm:ss").format(
                      "hh:mm A"
                    )} (${getKhmerPeriod(time_meeting)})`
                  : "No time selected"}
              </td>
            </tr>
            <tr>
              <td style={{ width: "100px", lineHeight: "2" }}>ទីកន្លែង :</td>
              <td style={{ lineHeight: "2" }}>{location}</td>
            </tr>
            <tr>
              <td style={{ width: "100px", lineHeight: "2" }}>
                សម្លៀកបំពាក់ :
              </td>
              <td style={{ lineHeight: "2" }}> {clothing_meeting} </td>
            </tr>
            <tr>
              <td
                colSpan={2}
                style={{
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex-end",
                    textAlign: "end",
                  }}
                >
                  <br /> <br /> <br />
                  <span
                    className="text-on-image-name_rightmanager_mission"
                    style={{ marginRight: 150 }}
                  >
                    {postion_signature}
                  </span>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    );
  };

  const Header = () => {
    return (
      <div className="text-on-image-name_rightmanager_mission">
        <div
          className="text-overlay"
          style={{
            top: 30,
            display: "flex",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="text-on-image-name_rightmanager_mission">
            <span>ព្រះរាជាណាចក្រកម្ពុជា</span> <br />
            <span>ជាតិ សាសនា ព្រះមហាក្សត្រ</span>
            <br />
            <img
              src={linkPath + "tacteing_font.jpg"}
              alt="tacteing font"
              style={{ width: "20%" }}
            />
          </div>
        </div>
        <div
          className="text-overlay"
          style={{
            marginLeft: 50,
            top: 80,
            display: "flex",
            width: "100%",
            alignItems: "start",
          }}
        >
          <div className="text-on-image-name_rightmanager_mission">
            <img
              src={Org_ImagePath}
              alt="Organization Logo"
              style={{ width: "70px", height: "70px", marginBottom: "5px" }}
            />
            <span>
              {OrgProfile.org_type <= 3 && (
                <span className="text-on-image-name_rightmanager_mission">
                  <br /> រដ្ឋបាលខេត្ត{do_in_provinceName}
                </span>
              )}
              {OrgProfile.org_type >= 4 && (
                <span className="text-on-image-name_rightmanager_mission">
                  <br /> មន្ទីរសុខាភិបាលនៃរដ្ឋបាលខេត្ត
                </span>
              )}
            </span>
            {OrgProfile.org_type != 1 && (
              <span className="text-on-image-name_rightmanager_mission">
                <br /> {org_cover_by}
              </span>
            )}{" "}
            <br />
            <span>{OrgProfile.org_name_kh}</span>
            <br />{" "}
            <span className="text-on-image-name_letters_mission">
              លេខ៖...........
            </span>
          </div>
        </div>

        <div
          className="text-overlay"
          style={{
            // backgroundColor: "#a3e4d7",
            right: 50,
            top: 200,
            display: "flex",
            width: "100%",
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        >
          <div
            style={{ textAlign: "end" }}
            className="text-on-image-name_letters_mission"
          >
            <span>{khmerDateDocument}</span>
            <br />
            <span>
              ធ្វើនៅ{do_in_provinceName}{" "}
              {formattedDate(formateDateClient(date_document))}
            </span>
          </div>
        </div>

        <div
          className="text-overlay"
          style={{
            top: 270,
            display: "flex",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="text-on-image-name_rightmanager_mission">
            <span>លិខិតអញ្ជើញ</span>
            <br />
            <img
              src={linkPath + "tacteing_font_001.jpg"}
              alt="tacteing font"
              style={{ width: "20%" }}
            />
            <br />
          </div>
        </div>
      </div>
    );
  };
  const HeaderSecondPage = () => {
    return (
      <div>
        <div
          style={{
            display: "flex",
            width: "100%",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            className="text-on-image-name_rightmanager_mission"
            style={{ textAlign: "center" }}
          >
            <span>ព្រះរាជាណាចក្រកម្ពុជា</span> <br />
            <span>ជាតិ សាសនា ព្រះមហាក្សត្រ</span>
            <br />
          </div>
          <img
            src={linkPath + "tacteing_font.jpg"}
            alt="tacteing font"
            style={{ width: 60 }}
          />
        </div>

        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "start",
          }}
        >
          <div className="text-on-image-name_rightmanager_mission">
            <img
              src={Org_ImagePath}
              alt="Organization Logo"
              style={{
                marginLeft: 20,
                width: "70px",
                height: "70px",
                marginBottom: "5px",
              }}
            />
            <span>
              {OrgProfile.org_type <= 3 && (
                <span className="text-on-image-name_rightmanager_mission">
                  <br /> រដ្ឋបាលខេត្ត{do_in_provinceName}
                </span>
              )}
              {OrgProfile.org_type >= 4 && (
                <span className="text-on-image-name_rightmanager_mission">
                  <br /> មន្ទីរសុខាភិបាលនៃរដ្ឋបាលខេត្ត
                </span>
              )}
            </span>
            {OrgProfile.org_type != 1 && (
              <span className="text-on-image-name_rightmanager_mission">
                <br /> {org_cover_by}
              </span>
            )}{" "}
            <br />
            <span>{OrgProfile.org_name_kh}</span>
          </div>
        </div>

        <div
          style={{
            // backgroundColor: "#a3e4d7",
            right: 50,
            top: 200,
            display: "flex",
            width: "100%",
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        >
          <div
            style={{ textAlign: "end" }}
            className="text-on-image-name_letters_mission"
          >
            <span>{khmerDateDocument}</span>
            <br />
            <span>
              ធ្វើនៅ{do_in_provinceName}{" "}
              {formattedDate(formateDateClient(date_document))}
            </span>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            width: "100%",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            className="text-on-image-name_rightmanager_mission"
            style={{ textAlign: "center" }}
          >
            <br />
            <br />
            <span>លិខិតអញ្ជើញ</span>
            <br />
            <img
              src={linkPath + "tacteing_font_001.jpg"}
              alt="tacteing font"
              style={{ width: "20%" }}
            />
            <br />
            <br />
          </div>
        </div>
      </div>
    );
  };
  const SingleStaffPage = ({ staff, index }) => (
    <div className="text-on-image-name_letters_mission">
      <HeaderSecondPage />

      <div>
        <div style={{ marginLeft: 100 }}>
          <table
            className="text-on-image-name_letters_mission"
            style={{ borderCollapse: "collapse", width: "100%" }}
          >
            <tr>
              <td
                style={{
                  width: "140px",
                  lineHeight: "2",
                  verticalAlign: "top", // Align content at the top
                }}
                className="text-on-image-name_rightmanager_mission"
              >
                <span> សូមអញ្ជើញ :</span>
              </td>
              <td style={{ verticalAlign: "top", lineHeight: "2" }}>
                <span
                  key={index}
                  className="text-on-image-name_rightmanager_mission"
                >
                  {staff.frontname} {staff.fullname} {staff.position} <br />
                </span>
              </td>
            </tr>
            <tr>
              <td
                style={{ width: "80px", lineHeight: "2", verticalAlign: "top" }}
              >
                ដើម្បី :
              </td>
              <td style={{ lineHeight: "2" }}> {reason} </td>
            </tr>
            <tr>
              <td style={{ width: "80px" }}>ពេលវេលា :</td>
              <td>
                {date_start} {" វេលាម៉ោង "}{" "}
                {time_meeting
                  ? `${dayjs(time_meeting, "HH:mm:ss").format(
                      "hh:mm A"
                    )} (${getKhmerPeriod(time_meeting)})`
                  : "No time selected"}
              </td>
            </tr>
            <tr>
              <td style={{ width: "100px", lineHeight: "2" }}>ទីកន្លែង :</td>
              <td style={{ lineHeight: "2" }}>{location}</td>
            </tr>
            <tr>
              <td style={{ width: "100px", lineHeight: "2" }}>
                សម្លៀកបំពាក់ :
              </td>
              <td style={{ lineHeight: "2" }}> {clothing_meeting} </td>
            </tr>
            <tr>
              <td
                colSpan={2}
                style={{
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex-end",
                    textAlign: "end",
                  }}
                >
                  <br /> <br /> <br />
                  <span
                    className="text-on-image-name_rightmanager_mission"
                    style={{ marginRight: 150 }}
                  >
                    {postion_signature}
                  </span>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  );
  return (
    <div>
      {/* First Page */}
      <div style={{ marginLeft: 20 }} className="print-page-mission">
        <Header />
        <Nodes />
        <FooterPagePrint location_contact={location_contact} />
      </div>

      {/* Second Page */}
      {liststaff.map((staff, index) => (
        <div
          key={index}
          className="single-staff-page"
          style={{
            margin: "50px",
            pageBreakAfter: index === liststaff.length - 1 ? "auto" : "always",
          }}
        >
          <SingleStaffPage staff={staff} index={index} />
        </div>
      ))}
    </div>
  );
};

export default ComponentToPrint_Index1;
